import axios from "axios";
import { jwtDecode } from 'jwt-decode';

const AxiosInstance = axios.create({
  baseURL: 'https://api.locationethiopia.com',
  headers: {
    "Content-Type": "application/json",
  },
});

AxiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("Finder-token"); 
    console.log(token, "gg");

    if (token) {
      const decodedToken = jwtDecode(token);
      const userRole = decodedToken.role;

      console.log(decodedToken, "nj");

      // Store the user role or any other info in a global state or context
      localStorage.setItem("userRole", userRole);  // For example, store the role in localStorage

      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default AxiosInstance;
